import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const depositSchema = z.object({
  id: z.string(),
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  coin: z.string(),
  network: z.string(),
  status: z.number(),
  address: z.string(),
  addressTag: z.string(),
  txId: z.string(),
  insertTime: z.number(),
  transferType: z.number(),
  confirmTimes: z.string(),
  unlockConfirm: z.number(),
  walletType: z.number(),
})

export type Deposit = z.infer<typeof depositSchema>
